/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

// import './style/contractor-mobile-scheduling.styl';
// import './style/tenant-mobile-scheduling.styl';

module.exports = {
    path: '/m/contractor/check-in/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./CheckInContainer'));
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/check-in/route.CheckIn.js